import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function Auth() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async () => {
    if (!email.trim()) return;

    try {
      setLoading(true);

      const { error } = await supabase.auth.signInWithOtp({
        email: email.trim(),
        options: {
          emailRedirectTo: process.env.REACT_APP_SITE_URL || window.location.origin,
        },
      });

      if (error) throw error;

      setEmailSent(true);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  if (emailSent) {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>urnotniche.com</h1>
        <div style={styles.content}>
          <p style={styles.message}>check your email</p>
          <p style={styles.emailHint}>{email}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>urnotniche.com</h1>
      <div style={styles.content}>
        <div style={styles.formContainer}>
          <input
            type="email"
            placeholder="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
            style={styles.input}
            disabled={loading}
          />
          <button 
            onClick={handleSubmit}
            style={styles.button}
            disabled={loading}
          >
            {loading ? 'sending...' : 'continue'}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#000',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    fontFamily: 'Impact, "Arial Black", sans-serif',
    fontSize: '48px',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '40px 20px',
    letterSpacing: '0.3em',
    textTransform: 'uppercase',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    maxWidth: '400px',
  },
  input: {
    background: '#000',
    border: '1px solid #fff',
    borderRadius: '0',
    padding: '16px',
    color: '#fff',
    fontSize: '16px',
    fontFamily: 'monospace',
  },
  button: {
    background: '#fff',
    color: '#000',
    border: 'none',
    borderRadius: '0',
    padding: '16px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontFamily: 'monospace',
  },
  message: {
    fontSize: '24px',
    fontFamily: 'monospace',
    marginBottom: '16px',
  },
  emailHint: {
    fontSize: '14px',
    color: '#666',
    fontFamily: 'monospace',
  },
};